/**
 * Kalgi PDP: cart-aware ATC / stepper, /cart/change.js, sync with theme cart events.
 */
(function () {
  var CART_UPDATE = 'cart:update';
  var CART_COUNT = 'cart:count:update';
  var refreshTimer = 0;

  function parseInt10(s) {
    var n = parseInt(String(s), 10);
    return Number.isFinite(n) ? n : 0;
  }

  function getFormById(formId) {
    return formId ? document.getElementById(formId) : null;
  }

  function dispatchCartCount(cart) {
    document.dispatchEvent(
      new CustomEvent(CART_COUNT, {
        detail: { item_count: cart.item_count },
        bubbles: true,
      })
    );
  }

  function dispatchCartUpdate(cart) {
    document.dispatchEvent(
      new CustomEvent(CART_UPDATE, {
        bubbles: true,
        detail: { resource: cart },
      })
    );
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (res) {
      if (!res.ok) throw new Error('cart');
      return res.json();
    });
  }

  function findLine(cart, variantId) {
    var vid = Number(variantId);
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === vid) {
        return { key: cart.items[i].key, quantity: cart.items[i].quantity };
      }
    }
    return { key: '', quantity: 0 };
  }

  function cartFromEvent(event) {
    var detail = event && event.detail;
    if (!detail) return null;
    if (detail.cartData && Array.isArray(detail.cartData.items)) return detail.cartData;
    if (detail.resource && Array.isArray(detail.resource.items)) return detail.resource;
    if (Array.isArray(detail.items)) return detail;
    return null;
  }

  function readMainVariantId() {
    var mainForm = document.querySelector('form.hdt-main-product-form');
    if (!mainForm) return 0;
    var input = mainForm.querySelector('input[name="id"]:not([disabled])');
    if (!input || !input.value) input = mainForm.querySelector('input[name="id"]');
    return input ? parseInt10(input.value) : 0;
  }

  function syncStickyVariantFromMain() {
    var mainForm = document.querySelector('form.hdt-main-product-form');
    var stickyForm = document.querySelector('form[id^="form-product-sticky"]');
    if (!mainForm || !stickyForm) return;
    var mainId = mainForm.querySelector('input[name="id"]');
    var stickyId = stickyForm.querySelector('input[name="id"]');
    if (mainId && stickyId && mainId.value) stickyId.value = mainId.value;
  }

  function applyState(root, quantity, lineKey) {
    root.dataset.lineKey = lineKey || '';
    var vid = readMainVariantId();
    if (vid) root.dataset.variantId = String(vid);

    var display = root.querySelector('[data-kalgi-qty-display]');
    var add = root.querySelector('.kalgi-pdp-atc__add');
    var stepper = root.querySelector('.kalgi-pdp-atc__stepper');
    var hiddenQty = root.querySelector('.kalgi-pdp-atc__form-qty');
    if (display) display.textContent = String(quantity);

    if (quantity > 0) {
      if (add) add.setAttribute('hidden', '');
      if (stepper) stepper.removeAttribute('hidden');
      if (hiddenQty) hiddenQty.setAttribute('disabled', '');
    } else {
      if (add) add.removeAttribute('hidden');
      if (stepper) stepper.setAttribute('hidden', '');
      if (hiddenQty) {
        hiddenQty.removeAttribute('disabled');
        hiddenQty.value = '1';
      }
    }

    var max = parseInt10(root.dataset.qtyMax) || 999999;
    var plus = root.querySelector('.kalgi-pdp-atc__btn--plus');
    if (plus) plus.disabled = quantity >= max;
  }

  function refreshAll() {
    syncStickyVariantFromMain();
    var vid = readMainVariantId();
    return fetchCart()
      .then(function (cart) {
        applyCart(cart, vid);
        dispatchCartCount(cart);
      })
      .catch(function () {});
  }

  function applyCart(cart, variantId) {
    if (!cart || !Array.isArray(cart.items)) return;
    syncStickyVariantFromMain();
    var vid = variantId || readMainVariantId();
    var roots = document.querySelectorAll('[data-kalgi-pdp-atc]');
    roots.forEach(function (root) {
      var v = vid || parseInt10(root.dataset.variantId);
      var found = findLine(cart, v);
      applyState(root, found.quantity, found.key);
    });
  }

  function initRoot(root) {
    var formId = root.dataset.formId;
    var form = getFormById(formId);
    var minusBtn = root.querySelector('.kalgi-pdp-atc__btn--minus');
    var plusBtn = root.querySelector('.kalgi-pdp-atc__btn--plus');
    var qtyStep = parseInt10(root.dataset.qtyStep) || 1;

    function change(delta) {
      var key = root.dataset.lineKey || '';
      var display = root.querySelector('[data-kalgi-qty-display]');
      var q = display ? parseInt10(display.textContent) : 0;
      var newQ = q + delta;
      if (!key && newQ > 0) return;
      if (newQ < 0) return;
      var max = parseInt10(root.dataset.qtyMax) || 999999;
      if (delta > 0 && newQ > max) return;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, newQ) }),
      })
        .then(function (res) {
          return res.json().then(function (cart) {
            if (!res.ok) throw new Error(cart.description || 'change failed');
            dispatchCartCount(cart);
            dispatchCartUpdate(cart);
          });
        })
        .catch(function (err) {
          console.error('[kalgi-pdp-atc]', err);
        });
    }

    if (minusBtn) minusBtn.addEventListener('click', function () {
      change(-qtyStep);
    });
    if (plusBtn) plusBtn.addEventListener('click', function () {
      change(qtyStep);
    });

    if (form) {
      form.addEventListener(
        'submit',
        function (e) {
          var add = root.querySelector('.kalgi-pdp-atc__add');
          if (add && add.hasAttribute('hidden')) {
            e.preventDefault();
            e.stopPropagation();
          }
        },
        true
      );
    }
  }

  function scheduleRefresh(delayMs) {
    if (refreshTimer) window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(function () {
      refreshTimer = 0;
      refreshAll();
    }, delayMs || 0);
  }

  function onVariantOrCart() {
    // Variant pickers can emit multiple back-to-back events.
    // Coalescing avoids redundant /cart.js calls during selection.
    scheduleRefresh(120);
  }

  function onCartUpdate(event) {
    var cart = cartFromEvent(event);
    if (cart) {
      applyCart(cart);
      dispatchCartCount(cart);
      return;
    }
    refreshAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  function boot() {
    document.querySelectorAll('[data-kalgi-pdp-atc]').forEach(initRoot);

    document.addEventListener(CART_UPDATE, onCartUpdate);

    document.addEventListener('variant:update', onVariantOrCart);
    document.addEventListener('variant:selected', onVariantOrCart);

    var mainForm = document.querySelector('form.hdt-main-product-form');
    var vidInput = mainForm && mainForm.querySelector('input[name="id"]');
    if (vidInput) {
      vidInput.addEventListener('change', function () {
        scheduleRefresh(0);
      });
    }
  }
})();
